import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { rootRoute } from './root'

const AboutApp = lazyRouteComponent(() => import('../pages/about-app'))

export const aboutAppRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'about-app',
  component: AboutApp,
})
